import { gql } from '@apollo/client'

export const REFRESH_MY_SKILL_STATUS = gql`
  mutation RetrieveMySkillStatus($id: HashedId!) {
    refreshMySkillStatus(id: $id)
  }
`

export const REFRESH_EMPLOYEE_SKILL_STATUS = gql`
  mutation RefreshEmployeeSkillStatus($id: HashedId!) {
    refreshEmployeeSkillStatus(id: $id)
  }
`

export const REFRESH_SUBORDINATES_OF_COMPANY_SKILL_STATUSES = gql`
  mutation RefreshSubordinatesOfCompanySkillStatuses($companyId: HashedId!) {
    refreshSubordinatesOfCompanySkillStatuses(companyId: $companyId)
  }
`

export const REFRESH_SUBORDINATES_SKILL_STATUSES = gql`
  mutation RefreshSubordinatesSkillStatuses($companyId: HashedId!, $reviewer: Boolean!, $buId: HashedId) {
    refreshSubordinatesSkillStatuses(companyId: $companyId, reviewer: $reviewer, buId: $buId)
  }
`

export const REFRESH_EMPLOYEES_OF_COMPANY_SKILL_STATUSES = gql`
  mutation RefreshEmployeesOfCompanySkillStatuses($companyId: HashedId!, $country: Country!) {
    refreshEmployeesOfCompanySkillStatuses(companyId: $companyId, country: $country)
  }
`
export const REFRESH_EMPLOYEES_OF_BU_SKILL_STATUSES = gql`
  mutation RefreshEmployeesOfBUSkillStatuses($businessUnitId: HashedId!) {
    refreshEmployeesOfBUSkillStatuses(businessUnitId: $businessUnitId)
  }
`

export const SEND_SKILL_STATUS_UPDATE_REMINDER_EMAIL = gql`
  mutation SendSkillStatusUpdateReminderEmail($employeeId: HashedId!) {
    sendSkillStatusUpdateReminderEmail(employeeId: $employeeId)
  }
`
